/**
 * Whether a tab that just won session ownership must upgrade to a full attach.
 * Keyed on whether it already drives the popup, not on `attachStatus` — a
 * listen-only bind reports "attached" as soon as it overhears the popup, so
 * gating on status leaves the new owner with no keepalive and no close polling.
 */
export const shouldUpgradeCallWindowOnOwnershipPromotion = ({
  becameOwner,
  hasStoredWindow,
  isDrivingCallWindow,
}: {
  becameOwner: boolean;
  hasStoredWindow: boolean;
  isDrivingCallWindow: boolean;
}): boolean => becameOwner && hasStoredWindow && !isDrivingCallWindow;
